import { Card } from "./components/Card";
import { Chart } from "./components/Chart";
import { CustomTable } from "./components/CustomTable";
import { Layout } from "providers/Layout";
import { AlertCircle } from "untitledui-js-base";
import { sampleData } from "./constants";
import { Redirect } from "shared/components/Redirect";
import { useAuthContext } from "providers/Auth";

export const CreditImpactView = () => {
  const { type } = useAuthContext();

  if (!(type.isRentReporting || type.isSDK)) return <Redirect href="/" />;

  return (
    <Layout sectionClassName="bg-background-900">
      <div className="animate-appear">
        <h1 className="text-2xl text-content-1000 font-bold mb-3">
          Credit impact
        </h1>
        <p className="text-sm text-content-400">
          Report includes enrollments started within report window.
        </p>
        <p className="text-sm text-content-400">
          Credit impact measured for 6 months from enrollment approval date.
        </p>
        <div className="mt-6 bg-background-1000 px-6 py-5 rounded-lg border border-alpha-100 shadow-xs flex gap-6 items-center">
          <AlertCircle className="stroke-primary-500" size="24" />
          <div className="h-[72px] border-r border-alpha-40" />
          <div>
            <p className="text-content-1000 text-base font-bold mb-2">
              Sample data is shown
            </p>
            <p className="text-content-500 text-sm">
              This is a sample report. We don&apos;t have sufficient data to
              show your actual impact yet.
            </p>
            <p className="text-content-500 text-sm">
              We will update this report as soon as we have enough information
              on enrollments.
            </p>
          </div>
        </div>
        <div className="my-6 md:grid grid-cols-3 gap-5 opacity-40">
          {sampleData.map((data) => {
            return <Card key={data.title} {...data} />;
          })}
        </div>
        <div className="opacity-40">
          <h3 className="text-base font-medium text-content-1000 mb-2">
            Impact by starting credit score
          </h3>
          <div className="relative w-[1440px] h-[484px] bg-background-1000 rounded-lg shadow-xs border border-alpha-100 mb-4 p-6">
            <Chart />
          </div>
          <CustomTable />
        </div>
      </div>
    </Layout>
  );
};
